import { RR_FILTER_TYPE } from '../../enum/filters/filter-type.enum';
import { RRIFilterBy } from './filter-by.interface';

export interface RRIFilterOutput<T> {
  type: RR_FILTER_TYPE;
  filterBy: RRIFilterBy<T>;
}
